/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2022-07-28 10:40:43
 * @FilePath: \frontend\src\utils\auth.js
 */
// import Cookies from 'js-cookie';
import store from '@/store';
import { signOut } from 'aws-amplify/auth';
import { errorMsg } from './message';
import { i18n } from '@/Lang/index';
import { ElNotification } from 'element-plus';
import { setGWDevOccupiedStatus } from '@/api/gateway';

// const TokenKey = 'userName';

// export function getToken() {
//   return Cookies.get(TokenKey);
// }

// export function setToken(token) {
//   var inFifteenMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);
//   return Cookies.set(TokenKey, token, {
//     expires: inFifteenMinutes,
//   });
// }

// export function removeToken() {
//   return Cookies.remove(TokenKey);
// }

/**
 * @return {Promise<void>}
 */
export async function amplifySignOut() {
  try {
    if (store.getters.occupyingGW.devId && store.getters.occupyingGW.areaId) {
      await setGWDevOccupiedStatus({
        tenant: store.getters.tenantId,
        area: store.getters.occupyingGW.areaId,
        gateway: store.getters.occupyingGW.devId,
        occupied: false,
      });
      store.dispatch('app/resetOccupyingGateway');
    }
    await signOut({ global: true });
    await store.dispatch('user/logout');
  } catch (error) {
    ElNotification({
      title: i18n.global.t('request.error'),
      message: errorMsg.Logout_failed,
      type: 'error',
      duration: 2000,
      customClass: 'notify',
    });
    throw error;
  }
}
